import React, {useState} from 'react';
import { Grid } from '@material-ui/core';
import SearchableTable from '../components/peoplerender';
import SearchableTable1 from '../components/toolsrender';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import { sendGetRequest, sendPostRequest, sendPutRequest } from 'utils/api';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import EmpIcon from '@material-ui/icons/PermContactCalendar';
import WfIcon from '@material-ui/icons/Repeat';
import InactiveIcon from '@material-ui/icons/Cancel'
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const options = [
	'Create',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;


function TabPanel(props) {
	const { children, value, index, ...other } = props;
	
	return (
		<div
		role="tabpanel"
		hidden={value !== index}
		id={`scrollable-force-tabpanel-${index}`}
		aria-labelledby={`scrollable-force-tab-${index}`}
		{...other}
		>
		{value === index && (
			<Box>
			{children}
			</Box>
		)}
		</div>
	);
	}
	  
	TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
	};
	
   function a11yProps(index) {
		return {
		  id: `scrollable-force-tab-${index}`,
		  'aria-controls': `scrollable-force-tabpanel-${index}`,
		};
	  }

const useStyles = makeStyles((theme) => ({
	root: {
	  width: '100%',
	},
	heading: {
	  fontSize: theme.typography.pxToRem(15),
	  fontWeight: theme.typography.fontWeightRegular,
	},
  }));

const UsersDetails = () => {
	const classes = useStyles();
	const history = useHistory();
	const [value, setValue] = React.useState(0);

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
  	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch(e.target.textContent){
			case 'Create':
				history.push({pathname: '/users/create'});
				break;
			case 'Back':
				history.goBack();
				break;
			default:
		}
		
		setAnchorEl(null);
	};

	const handleChange = (event, newValue) => {
    	setValue(newValue);
  	};

	/*const handleChange = (event) => {
            const table = 'upload'

			const data = new FormData() ;
			data.append('file', event.target.files[0]);

			sendPostRequest(`/${table}/famasupload`, data).then((res) => {
					console.log('File Uploaded')
				 });  
	}*/

	return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
					<MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
				
				>
					<span>User Role Details</span>
				</IconButton>
				
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 5,
						width: '20ch',
					},
					}}
				>
					{options.map((option) => (
					<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e)=>handleClose(e)}>
						{option}
					</MenuItem>
					))}
				</Menu>
			</div>


			<AppBar position="static" color="default">
	<Tabs
	  value={value}
	  onChange={handleChange}
	  variant="scrollable"
	  scrollButtons="on"
	  indicatorColor="primary"
	  textColor="primary"
	  aria-label="scrollable force tabs example"
	>
	  <Tab label="Employee List" icon={<EmpIcon />} {...a11yProps(0)} />
	  <Tab label="Inactive Records" icon={<InactiveIcon />} {...a11yProps(1)} />
	</Tabs>
  </AppBar>

  <TabPanel value={value} index={0}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>User Role Details</p> 
			<Grid item xs={12} md={12}>
				<SearchableTable
					table = {'roles'}
					filterTable = ""
					defaultSortColumn = "empName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { true }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'empName',
							displayedHeader: 'Employee Name',
							displayedLength: 50,
							withList: false,
						},
						{
							key: 'roleType',
							displayedHeader: 'Role Type',
							displayedLength: 50,
							withList: false,
						}
						
					]}
					displayRows = {[
						//{ key: 'idMaster', displayedHeader: 'ID', type: 'id' },
						{
							key: 'empName',
							displayedHeader: 'Employee Name',
							displayedLength: 50,
						},
						{
							key: 'empId',
							displayedHeader: 'Employee ID',
							displayedLength: 50,
						},
						{
							key: 'roleType',
							displayedHeader: 'Role Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						}
					]}
				/>
			</Grid>
 </TabPanel>	

  <TabPanel value={value} index={1}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Inactive Records</p> 

	  <Grid item xs={12} md={12}>
				<SearchableTable1
					table = {'inactive'}
                    qString = "&type=roles" 
					filterTable = ""
					defaultSortColumn = "empName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'empName',
							displayedHeader: 'Employee Name',
							displayedLength: 50,
							withList: false,
						},
						{
							key: 'roleType',
							displayedHeader: 'Role Type',
							displayedLength: 50,
							withList: false,
						}
						
					]}
					displayRows = {[
						//{ key: 'idMaster', displayedHeader: 'ID', type: 'id' },
						{
							key: 'empName',
							displayedHeader: 'Employee Name',
							displayedLength: 50,
						},
						{
							key: 'empId',
							displayedHeader: 'Employee ID',
							displayedLength: 50,
						},
						{
							key: 'roleType',
							displayedHeader: 'Role Type',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
						{
							key: 'updatedDate',
							displayedHeader: 'Updated Date',
							displayedLength: 50,
						}
					]}
				/>
			</Grid>
  </TabPanel>	  		

		 
			{/*<p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Upload</p>
			     <Grid item xs={12} md={8} style={{'width':'100%'}}>
						<input type="file" onChange={handleChange} />
				</Grid>*/}
			
			
		</Content>
	);
};

export default UsersDetails;
